/* TypeScript file generated from DefaultLayoutContentRoute.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as DefaultLayoutContentRouteJS from './DefaultLayoutContentRoute.re.mjs';

import type {props as DefaultLayoutContentPage_props} from '../../../src/components/pages/DefaultLayoutContentPage.gen';

export const Component: React.ComponentType<{}> = DefaultLayoutContentRouteJS.Component as any;
